<template>
  <div>
    <div class="vx-card p-6">

      <h1>Wykres tolerowanych przestawień</h1>

      <br>

      <p>Do wyszukiwania klauzul używamy techniki "fuzzy string matching". Oznacza to,
        że wyszukujemy ciągów znakowych podobnych do wzorców dopuszczając pewne różnice.
        Wykres poniżej przedstawia dopuszczalną liczbę odstępstw między wzorcami klauzul
        a zaznaczonymi fragmentami umów.</p>

      <br>

      <vue-apex-charts ref="apexChart" type="line"
                       height="700" width="100%" :options="chartOptions" :series="chartData"/>

    </div>
  </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  import MAX_ERRORS_CHART from '../graphql/max_errors.gql'

  export default {
    name: "Chart",
    data() {
      return { max_errors: [] }
    },
    async created() {
      const { data: { max_errors } } = await this.$apollo.query({
        query: MAX_ERRORS_CHART
      });

      this.max_errors = max_errors;
    },
    computed: {
      chartOptions() {
        return {
          xaxis: {
            title: { text: 'Liczba znaków w sprawdzanych klauzulach' },
            categories: this.max_errors.map(c => c.x)
          },
          yaxis: { title: { text: 'Dopuszczalna liczba przestawień klasyfikująca zliczenie' } }
        }
      },
      chartData() {
        return [{
          name: 'Błędne Litery',
          data: this.max_errors.map(c => c.y)
        }];
      }
    },
    components: {
      VueApexCharts
    }
  }
</script>

<style scoped>

</style>
